import { render } from "./Revisoes.vue?vue&type=template&id=675f8e14&scoped=true"
import script from "./Revisoes.vue?vue&type=script&lang=js"
export * from "./Revisoes.vue?vue&type=script&lang=js"

import "./Revisoes.vue?vue&type=style&index=0&id=675f8e14&scoped=true&lang=css"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-675f8e14"]])

export default __exports__